/* This config reduces the space in PDF reducing the margins and paddings as it overrides the box model constraints.
	This is specific to model evaluator. In order to use this reduced spacing in PDF for other apps, it needs to be tested once.
*/
export const ReducedSpacingConfig = {
	sectionTitle: {
		heading: { paddingTop: 0, paddingBottom: 0 }
	},
	standardizedPerformanceNav: {
		staticParagraph: { paddingBottom: 5 },
		disclosure: { paddingTop: 2, paddingBottom: 5 }
	},
	tableCompositionHelper: {
		boxModelConstraint: { paddingLeft: 2, paddingRight: 2, paddingTop: 4, paddingBottom: 3, useFullHeight: true },
		tableColumnBoxModelConstraints: 2,
		holdingsColumnProportionsHeaderRow: {
			5: [40, 12, 12, 12, 12, 12],
			6: [40, 10, 10, 10, 10, 10, 10],
			7: [37, 9, 9, 9, 9, 9, 9, 9],
			8: [36, 8, 8, 8, 8, 8, 8, 8, 8],
			9: [37, 7, 7, 7, 7, 7, 7, 7, 7, 7],
			10: [40, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6],
			11: [34, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6],
			12: [34, 5.5, 5.5, 5.5, 5.5, 5.5, 5.5, 5.5, 5.5, 5.5, 5.5, 5.5, 5.5],
			13: [22, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6],
			14: [21.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6],
			15: [19, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4]
		},
		holdingsColumnProportionsBodyRow: {
			5: [10, 30, 12, 12, 12, 12, 12],
			6: [10, 30, 10, 10, 10, 10, 10, 10],
			7: [10, 27, 9, 9, 9, 9, 9, 9, 9],
			8: [10, 26, 8, 8, 8, 8, 8, 8, 8, 8],
			9: [10, 27, 7, 7, 7, 7, 7, 7, 7, 7, 7],
			10: [8, 32, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6],
			11: [8, 26, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6],
			12: [8, 26, 5.5, 5.5, 5.5, 5.5, 5.5, 5.5, 5.5, 5.5, 5.5, 5.5, 5.5, 5.5],
			13: [8, 14, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6],
			14: [8, 13.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6, 5.6],
			15: [7, 12, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4, 5.4]
		}
	},
	fundPerformancePanelHelper: {
		headerRowPanel: { paddingBottom: 2, borderBottom: 0.25, borderBottomColor: '#000', marginBottom: 2 },
		body: { paddingBottom: 0 },
		asOfDatePanel: { paddingBottom: 2 }
	}

};
